import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App.tsx';
import { initAdsense } from './lib/ads';
import { initAnalytics } from './lib/analytics';
import { hasConsent } from './lib/consent';

// GDPR / ePrivacy: don't load tracking or ads until the visitor has
// accepted cookies. The CookieBanner component re-runs these inits
// inline once the user clicks Accept, so first-visit consent doesn't
// require a page reload. See docs/ads-integration.md for the
// threat-model boundary.
if (hasConsent()) {
  initAnalytics();
  initAdsense();
}

// A file dropped anywhere outside the Dropzone (a modal overlay, the
// footer, …) would otherwise make the browser navigate to the file,
// destroying the SPA and every in-memory session. preventDefault at the
// window level neutralises that; the Dropzone's own handlers call
// stopPropagation so its drop behaviour is unchanged.
window.addEventListener('dragover', (e) => e.preventDefault());
window.addEventListener('drop', (e) => e.preventDefault());

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
